if (typeof ProductImageZoom != "function") {

  /* =========================================================
     RÉGLAGES DU ZOOM – Les Grappes
     1    = image entière visible à l'écran (taille « contain »)
     1.5  = 50 % plus grande que l'écran (navigation à la souris)
     maxUpscale : 1 = jamais au-delà de la taille réelle du fichier
                  0 = pas de limite
     ========================================================= */
  const LG_ZOOM = {
    scaleDesktop: 1,
    scaleMobile: 2,
    maxUpscale: 1
  };

  class ProductImageZoom2 extends HTMLElement {
    constructor() {
      super();

      if (document.getElementById("zoom")) {
        this.zoom = document.getElementById("zoom");
      } else {
        this.zoom = document.createElement("div");
        this.zoom.id = "zoom";
        this.zoom.innerHTML = `
          <img />
          <span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>
          <span class="zoom__loader">${KROWN.settings.symbols.zoom_loader}</span>
          <div class="zoom__overlay"></div>
        `;
        document.body.append(this.zoom);
        this.zoom.querySelector(".zoom__exit").addEventListener("click", this._productZoomUnmount.bind(this));
      }

      this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this);
      this.onResizeHandlerBinded = this.onResizeHandler.bind(this);

      this.addEventListener("click", () => {
        this.zoom.classList.add("opened");
        this.image = this.zoom.querySelector("img");
        this.image.src = this.getAttribute("data-image");
        if (this.image.naturalWidth > 0) {
          this._productZoomMount();
        } else {
          this.image.addEventListener("load", this._productZoomMount.bind(this), { once: true });
        }
      });
    }

    isTouch() {
      return document.body.classList.contains("touch") || document.body.classList.contains("touchevents");
    }

    getScale() {
      return window.innerWidth > 768 ? LG_ZOOM.scaleDesktop : LG_ZOOM.scaleMobile;
    }

    position(clientX, clientY) {
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const w = this.image.offsetWidth;
      const h = this.image.offsetHeight;
      const touch = this.isTouch();

      let x, y;
      if (w > vw) {
        x = touch ? 0 : clientX * (vw - w) / vw;
      } else {
        x = (vw - w) / 2;
      }
      if (h > vh) {
        y = touch ? 0 : clientY * (vh - h) / vh;
      } else {
        y = (vh - h) / 2;
      }

      this.image.style.left = x + "px";
      this.image.style.top = y + "px";
    }

    onMouseMoveHandler(e) {
      window.clientX = e.clientX;
      window.clientY = e.clientY;
      this.position(e.clientX, e.clientY);
    }

    onResizeHandler() {
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const ratio = parseFloat(this.image.dataset.ratio) || 1;

      // Taille « contain » : l'image entière tient dans l'écran
      let w = vw;
      let h = vw / ratio;
      if (h > vh) {
        h = vh;
        w = vh * ratio;
      }

      // Application du coefficient
      const s = this.getScale();
      w *= s;
      h *= s;

      // Limite à la taille réelle du fichier
      if (LG_ZOOM.maxUpscale > 0) {
        const maxW = this.image.naturalWidth * LG_ZOOM.maxUpscale;
        if (w > maxW) {
          w = maxW;
          h = maxW / ratio;
        }
      }

      this.image.style.width = w + "px";
      this.image.style.height = h + "px";

      const cx = typeof window.clientX === "number" ? window.clientX : vw / 2;
      const cy = typeof window.clientY === "number" ? window.clientY : vh / 2;
      this.position(cx, cy);
    }

    _productZoomMount() {
      this.image.style.left = 0;
      this.image.style.top = 0;
      window.addEventListener("mousemove", this.onMouseMoveHandlerBinded, { passive: true });
      this.image.dataset.ratio = this.image.naturalWidth / this.image.naturalHeight;
      window.addEventListener("resize", this.onResizeHandlerBinded, { passive: true });
      this.onResizeHandler();

      setTimeout(() => {
        if (this.isTouch()) {
          this.zoom.scrollTop = Math.max(0, (this.image.offsetHeight - window.innerHeight) / 2);
          this.zoom.scrollLeft = Math.max(0, (this.image.offsetWidth - window.innerWidth) / 2);
        }
        this.zoom.classList.add("loaded");
      }, 50);
    }

    _productZoomUnmount() {
      this.zoom.classList.remove("opened");
      setTimeout(() => {
        window.removeEventListener("resize", this.onResizeHandlerBinded);
        window.removeEventListener("mousemove", this.onMouseMoveHandlerBinded);
        const image = document.querySelector("#zoom img");
        image.src = "";
        image.className = "";
        image.style = "";
        this.zoom.classList.remove("loaded");
      }, 300);
    }
  }

  if (typeof customElements.get("product-image-zoom") > "u") {
    customElements.define("product-image-zoom", ProductImageZoom2);
  }
}